export type RosPosition = {
  x: number;
  y: number;
  z: number;
};

export type FrameID = 'map' | 'latlon' | 'world' | 'gps' | 'imu' | 'ground' | 'probe';

export interface HeaderTimestamp {
  secs: number;
  nsecs: number;
}

export interface Header {
  stamp?: HeaderTimestamp;
  frame_id?: FrameID; // this only comes back from ROS right now
  seq?: string; // this only comes back from ROS right now
}

export interface RelativeOffset {
  x: number;
  y: number;
  z: number;
}

export interface CoreMsg {
  header: Header;
  result: number;
  postlaunch_depth_error: number;
  status_code: number;
  robot_id?: string;
  job_id?: string;
  sample_id?: string;
  sample_sn?: number;
  initiator?: number;
  duration?: number;
  target_depth?: number;
  big_motor_used?: number;
  prelaunch_depth_error?: number;
  location?: RosPosition;
  location_error?: RelativeOffset;
  core_location?: RosPosition;
  arm_location?: RosPosition;
  offset: RelativeOffset;
  arm_centered: boolean;
  core_offset: number;
  core_diameter?: string;
}

export interface NavLegCompleteMsg {
  header: Header;
  // TODO fill in properties
  start_time: number;
  status: number;
  type: number;
  start_location: RosPosition;
  end_location: RosPosition;
  duration: number;
  length: number;
  average_speed: number;
  average_crosstrack_error: number;
  average_speed_error: number;
}

export interface DumpCompleteMsg {
  header: Header;
  // TODO fill in properties
}

export type RosWaypoint = {
  sample_id: string;
  command: number;
  position: RosPosition;

  // these come back from ROS...
  start_depth?: number;
  end_depth?: number;
};

export type RosBoundary = {
  points: RosPosition[];
};

export type RosSample = {
  header: Header;
  job_id: string;
  sample_id: string;
  barcode_id: string;
  start_depth: number;
  end_depth: number;

  // these come back from ROS...
  sample_sn?: number;
  weight?: number;
  robot_id?: string;
  location?: RosPosition;
};

export type RosMissionMsg = {
  header: Header;
  name: string;
  job_id: string;
  last_modified: number;
  utm_zone: string;
  nav_checksum: string;
  outer_boundaries: RosBoundary[];
  inner_boundaries: RosBoundary[];
  waypoints: RosWaypoint[];
  samples: RosSample[];
};

export type RosMissionMsgWithFieldParam = RosMissionMsg & {
  field_param: number[];
};

export const RobotControlRoles = ['unknown', 'control', 'view'] as const;
export type RobotControlRole = (typeof RobotControlRoles)[number];

export enum StartAt {
  GoToStart = 1,
  GoToSample = 2,
  StartAfterSample = 3,
  SpecificWaypoint = 4,
  GoToEnd = 5,
}
